/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MapRelayContentToServiceModel } from '../model/mapRelayContentToServiceModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MapContentToServiceService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mapContentToServiceDelete(model: MapRelayContentToServiceModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public mapContentToServiceDelete(model: MapRelayContentToServiceModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public mapContentToServiceDelete(model: MapRelayContentToServiceModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public mapContentToServiceDelete(model: MapRelayContentToServiceModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling mapContentToServiceDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/mapcontenttoservice/Delete`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param relayContentId 
     * @param serviceShortCode 
     * @param keyword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mapContentToServiceGetAll(serviceId?: string, relayContentId?: string, serviceShortCode?: string, keyword?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MapRelayContentToServiceModel>>;
    public mapContentToServiceGetAll(serviceId?: string, relayContentId?: string, serviceShortCode?: string, keyword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MapRelayContentToServiceModel>>>;
    public mapContentToServiceGetAll(serviceId?: string, relayContentId?: string, serviceShortCode?: string, keyword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MapRelayContentToServiceModel>>>;
    public mapContentToServiceGetAll(serviceId?: string, relayContentId?: string, serviceShortCode?: string, keyword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }
        if (relayContentId !== undefined && relayContentId !== null) {
            queryParameters = queryParameters.set('relayContentId', <any>relayContentId);
        }
        if (serviceShortCode !== undefined && serviceShortCode !== null) {
            queryParameters = queryParameters.set('serviceShortCode', <any>serviceShortCode);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MapRelayContentToServiceModel>>(`${this.basePath}/api/mapcontenttoservice/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mapContentToServiceGetById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<MapRelayContentToServiceModel>;
    public mapContentToServiceGetById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MapRelayContentToServiceModel>>;
    public mapContentToServiceGetById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MapRelayContentToServiceModel>>;
    public mapContentToServiceGetById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MapRelayContentToServiceModel>(`${this.basePath}/api/mapcontenttoservice/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param map 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mapContentToServiceMap(map: MapRelayContentToServiceModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public mapContentToServiceMap(map: MapRelayContentToServiceModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public mapContentToServiceMap(map: MapRelayContentToServiceModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public mapContentToServiceMap(map: MapRelayContentToServiceModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (map === null || map === undefined) {
            throw new Error('Required parameter map was null or undefined when calling mapContentToServiceMap.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/mapcontenttoservice/createmap`,
            map,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mapContentToServiceUpdate(model: MapRelayContentToServiceModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public mapContentToServiceUpdate(model: MapRelayContentToServiceModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public mapContentToServiceUpdate(model: MapRelayContentToServiceModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public mapContentToServiceUpdate(model: MapRelayContentToServiceModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling mapContentToServiceUpdate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/mapcontenttoservice/Update`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
